export default function WhyDifferentSection() {
  const differentiators = [
    "Registered State Dept. courier — not a reseller or aggregator",
    "Daily reserved agency submission slots",
    "20–80% cheaper than FedEx Office or Staples passport services",
    "Expert document review before submission — catches errors that cause delays",
    "Real-time tracking from submission to delivery",
    "U.S.-based customer support — real humans by phone and email",
    "24 physical drop-off locations nationwide",
    "A+ BBB accredited with 20+ years in business",
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">What Sets Us Apart</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Makes Fast Passport Center{" "}
            <span className="text-[#F6C344]">Different</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#1A365D] mb-5 leading-tight">
              We Have Reserved Daily Access —{" "}
              <span className="text-[#F6C344]">The Public Doesn't</span>
            </h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5">
              Fast Passport Center is registered under the U.S. Department of State's Hand Carry Program. That means we are <strong className="text-[#1A365D]">allotted a limited number of in-person drop-off slots at regional passport agencies each day</strong> — slots that are not available to the general public and cannot be obtained by walking in or calling for an appointment. Each drop-off is processed in a specified number of days, which is how we can guarantee predictable turnaround times.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-8">
              When you go through a post office, your application waits in the mail system. When you use a retail service like FedEx or Staples, your application goes to a middleman who then sends it to someone like us anyway. When you use Fast Passport Center directly, your application goes straight to the agency — same or next business day — and comes back to you by overnight FedEx.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {differentiators.map((item, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-fill text-[#0D7A5F] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="text-gray-700 text-sm leading-snug">{item}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="flex-shrink-0 w-full lg:w-[420px]">
            <div className="relative bg-gradient-to-br from-[#0D3B3B] to-[#156064] rounded-2xl p-8 text-white overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#F6C344]/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#F6C344]/8 rounded-full translate-y-1/2 -translate-x-1/2"></div>
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#F6C344]/20 mb-6">
                  <i className="ri-government-line text-[#F6C344] text-2xl"></i>
                </div>
                <h4 className="font-serif text-xl font-bold mb-3">Direct Courier Access</h4>
                <p className="text-white/70 text-sm leading-relaxed mb-6">
                  We don't mail your application — our authorized couriers use one of our limited, State Department-allotted drop-off slots to hand-deliver your application directly to the passport agency. Same or next business day, every time.
                </p>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#F6C344]"></div>
                    <span className="text-white/80 text-sm">No mail delays</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#F6C344]"></div>
                    <span className="text-white/80 text-sm">No middleman markup</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#F6C344]"></div>
                    <span className="text-white/80 text-sm">Reserved daily slots</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-[#F6C344]"></div>
                    <span className="text-white/80 text-sm">Overnight return delivery</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}